module.exports = __webpack_public_path__ + "img/filter.4e108bf9.svg";